

export const FormSection=()=>{
    return(
        <div className="form-section">
            <div className='form-section_row'>
                <img src={require('../../../../static/main-logo.png')}/>
                <br/>
                <span>Stay on the saddle!</span>
                <div className='form-section_form'>
                    <input placeholder="enter your email"/><button>GO</button>
                </div>
            </div>
        </div>
    )
}